import { prepareCommonShaftData, sendShaft } from "./sendShaftCommon";
import { type LinearConfiguratorState } from "../../Linear/redux/types";
import { type LinearConfiguration } from "../../Linear/models";

export function sendShaftStepChange(linearState: LinearConfiguratorState): Promise<LinearConfiguration> {
  const data = prepareCommonShaftData(linearState);

  data.cpqAction = "NAV_TO_CSTIC_IN_GROUP";

  return sendShaft(data);
}

export function sendShaftMiscChange(linearState: LinearConfiguratorState): Promise<LinearConfiguration> {
  const data = prepareCommonShaftData(linearState);

  data.cpqAction = "TOGGLE_GROUP";

  return sendShaft(data);
}
